import React from "react";
// import {FEATURE_TOGGLE_TO_BE_ACCOUNTANT_V2} from "../../../config";
import { Tooltip } from "antd";

import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import VaporTab from "../../vapor/tab/indexOld";

const SectionHeader = ({tabActive, setTabActive}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <div style={{display: "flex", alignItems: "center",
      justifyContent: "space-between"}}>
      <VaporTab
            
        containerStyle={{ height: "80px", fontSize: "24px", lineHeight: "80px", fontWeight: "600" }}
        itemsStyle={{ width: "220px" }}
        items={[
          {
            value:  1,
            content: "Da contabilizzare"
          },
          {
            value: 2,
            content: "Contabilizzati"
          }      
        ]}
        active={tabActive}
        onChange={(i) => {
          // Passando da un tab all'altro le info dei da contabilizzare restavano nella sezione 
          // contabilizzati e viceversa. Andiamo a ripulire i dati.
          dispatch({type: "CLEAR_DASHBOARD_DATA"});
          setTabActive(i.value);
        }
        }
      />
      <div className="iconOldTab">
        <Tooltip color="rgb(0, 80, 117)" 
          title={<FormattedMessage id="preCog.sections.cespiti.tooltip" />} 
          placement="top" trigger="hover" 
          getPopupContainer={trigger => trigger.parentNode} 
        >
          <div data-testid="cespitiTab" onClick={e => setTabActive(4)}>
            <FontAwesomeIcon icon={["far", "car-building"]} />
          </div>
        </Tooltip>
        <Tooltip color="rgb(0, 80, 117)" 
          title={<FormattedMessage id="preCog.sections.ritenute.tooltip" />} 
          placement="top" 
          trigger="hover" 
          getPopupContainer={trigger => trigger.parentNode} >
          <div data-testid="ritenuteTab" onClick={e => setTabActive(3)}>
            <FontAwesomeIcon icon={["far", "badge-percent"]} />
          </div>
        </Tooltip>
        <Tooltip color="rgb(0, 80, 117)" 
          title={<FormattedMessage id="preCog.sections.usedGoods.tooltip" />} 
          placement="top" 
          trigger="hover" 
          getPopupContainer={trigger => trigger.parentNode} >
          <div data-testid="usedGoodsTab" onClick={e => navigate("/used-goods")}>
            <FontAwesomeIcon icon={["far", "prescription-bottle-alt"]} />
          </div>
        </Tooltip>
      </div>
    </div>
  );
};

export default SectionHeader;